import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getCookie } from '../helpers/utils';

const API_URL = (tournament_id: number) => `/api/tournament/${tournament_id}`;

const API_URL_STATUS = (tournament_id: number) => `/api/v1/tournament_management/${tournament_id}/change_status/`;
const API_URL_COPY = (tournament_id: number) => `/api/v1/tournament_management/${tournament_id}/create_copy/`;

@Injectable({
  providedIn: 'root'
})
export class TournamentService {

  constructor(
    private http: HttpClient,
  ) {
  }


  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }


  get(tournament_id: number) {
    return this.http.get(API_URL(tournament_id));
  }

  updateStatus(tournament_id: number, status: string) {
    return this.http.put(API_URL_STATUS(tournament_id), {
      status,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  createCopy(tournament_id: number) {
    return this.http.post(API_URL_COPY(tournament_id), {
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }
}
